export const SIDEBAR_NAVIGATION_WIDTH = 150
